// Versions of the legal documents a user accepts at signup. These are recorded
// against the account, so they must move whenever the documents change: edit a
// page's "Last updated" line and edit the matching constant here in the same
// commit, or the stored consent points at text nobody agreed to.
//
// The two documents now live on separate pages and version independently:
//   TERMS_VERSION   -> components/Pages/TermsAndConditions.js  (/terms)
//   PRIVACY_VERSION -> components/Pages/PrivacyPolicy.js       (/privacy)
// PrivacyPolicy.js renders PRIVACY_VERSION in its hero, so that page and this
// constant cannot drift apart silently.
export const TERMS_VERSION = '2026-09-18';
export const PRIVACY_VERSION = '2026-09-24';
